import React from 'react'
import { withIcon } from '../../withIcon'

function PlayPreviewIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.88975 17.0001H19.1102C19.2814 17.0001 19.4192 16.8611 19.4192 16.6899V7.31016C19.4192 7.13833 19.2814 7 19.1102 7H4.88975C4.71862 7 4.58084 7.13833 4.58084 7.31016V16.6899C4.58084 16.8611 4.71862 17.0001 4.88975 17.0001ZM10.2001 14.4554L15.014 12L10.2001 9.5446V14.4554Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PlayPreviewIcon)
